import axiosClient from "api/axiosInstance";
import { Contract } from "api/models/Contract";
import { Contracts } from "api/models/Contracts";
import { GridRowId } from "@mui/x-data-grid";
import { buildQueryString } from "../../helpers/filters";

export const getContracts = async (
  page: number,
  size: number,
  filters: { [key: string]: string },
): Promise<Contracts> => {
  const client = axiosClient();

  const queryString = Object.keys(filters)
    .filter((key) => !!filters[key])
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`,
    )
    .join("&");

  const response = await client.get(
    `/contracts?${queryString}&page=${page}&size=${size}`,
  );

  return response.data;
};

export const sendContract = async (
  data: { firstDate: string; meteringPoints: GridRowId[]; lastDate: string },
  clientId: number,
): Promise<Contract> => {
  const client = axiosClient();

  const response = await client.post(
    `/clients/${clientId}/send-contract`,
    data,
  );

  return response.data;
};

export const updateContractsEndDate = async (
  contractId: number,
  data: {
    endDate: string;
  },
): Promise<Contract> => {
  const client = axiosClient();

  const response = await client.put(`/contracts/${contractId}`, data);

  return response.data;
};

export const deleteContract = async (contractId: number): Promise<any> => {
  const client = axiosClient();

  const response = await client.delete(`/contracts/${contractId}`);

  return response.data;
};

export const fetchExportContracts = async (filters: {
  [key: string]: string;
}): Promise<void> => {
  const client = axiosClient();

  const queryString = buildQueryString(filters);

  const response = await client.get(`/contracts/export?${queryString}`, {
    responseType: "blob",
  });

  return response.data;
};

export const getBaseLoads = async (clientId: number): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(
    `/contracts/base-load?clientId=${clientId}`,
  );

  return response.data;
};

export const saveBaseLoad = async (data: any): Promise<any> => {
  const client = axiosClient();

  const response = await client.post(`/contracts/base-load`, data);

  return response.data;
};

export const deleteBaseLoad = async (baseLoadId: number): Promise<any> => {
  const client = axiosClient();

  const response = await client.delete(`/contracts/base-load/${baseLoadId}`);

  return response.data;
};

export const getPortfolioContracts = async (
  clientId: number,
): Promise<Contracts> => {
  const client = axiosClient();

  const response = await client.get(`/portfolio-contracts/client/${clientId}`);

  return response.data;
};

export const addPortfolioContract = async (postData: {
  clientId: number;
  validFrom: string;
  validTo: string;
}): Promise<Contract> => {
  const client = axiosClient();

  const response = await client.post(`/portfolio-contracts`, postData);

  return response.data;
};

export const updatePortfolioContractsEndDate = async (
  id: number,
  data: {
    endDate: string;
  },
): Promise<Contract> => {
  const client = axiosClient();

  const response = await client.put(`/portfolio-contracts/${id}`, data);

  return response.data;
};

export const deletePortfolioContract = async (id: number): Promise<any> => {
  const client = axiosClient();

  const response = await client.delete(`/portfolio-contracts/${id}`);

  return response.data;
};
